type Props = {
  strings: BidsRegistration.Localizations;
};

export default function OnlineBid(props: Props) {
  const formStrings = props.strings.online_bid;

  return (
    <div className="online-bid">
      <div
        className="intro"
        // eslint-disable-next-line @eslint-react/dom-no-dangerously-set-innerhtml
        dangerouslySetInnerHTML={{ __html: formStrings.intro_html }}
      />
    </div>
  );
}
